import React from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'material-ui'
import styles from './styles/calendar.css'

const CalendarHours = ({ numHours, startOfDay }) => {
  const hours = []
  const start = startOfDay
  for (let i = start; i < start + (numHours - 1); i++) {
    hours.push({
      currentHour: ((i - 1) % 12) + 1,
      amOrPm: i < 12 ? 'a' : 'p',
    })
  }
  return (
    <div className={styles.hourColumn}>
      <Divider style={{ marginTop: '75px' }} />
      <div className={styles.beforeHoursPadding} />
      {hours.map(({ amOrPm, currentHour }) => (
        <div className={styles.hourRow} key={`${currentHour}${amOrPm}`}>
          {`${currentHour}${amOrPm}`}
        </div>
      ))}
    </div>
  )
}

CalendarHours.propTypes = {
  numHours: PropTypes.number.isRequired,
  startOfDay: PropTypes.number.isRequired,
}

export default CalendarHours



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/CalendarHours.js